import type { User } from 'oidc-client-ts';

import { usersService } from './users.service';

const LOGIN_TRACK_PREFIX = 'agentic360:audit-login:';

function buildLoginTrackKey(user: User | null): string | null {
  const subject = user?.profile?.sub;
  if (!subject) {
    return null;
  }

  const sessionMarker = typeof user.expires_at === 'number' ? String(user.expires_at) : 'session';
  return `${LOGIN_TRACK_PREFIX}${subject}:${sessionMarker}`;
}

export async function trackLoginOnce(user: User | null, clientApp: string): Promise<void> {
  const storageKey = buildLoginTrackKey(user);
  if (!storageKey) {
    await usersService.trackLogin({ clientApp });
    return;
  }

  if (window.sessionStorage.getItem(storageKey)) {
    return;
  }

  try {
    await usersService.trackLogin({ clientApp });
    window.sessionStorage.setItem(storageKey, new Date().toISOString());
  } catch (error) {
    window.sessionStorage.removeItem(storageKey);
    throw error;
  }
}
